<template>
  <div class="card" v-if="liveStreams.length > 0">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Most Views Live Stream</h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table :data="liveStreams">
        <template slot="columns">
          <th>Streamer Name</th>
          <th>Title</th>
          <th>Description</th>
          <th>Total Comments</th>
          <th>Total Views</th>
        </template>

        <template slot-scope="{row}">
          <!-- <td>{{ row.streamer.name }}</td> -->
          <td>{{ row.streamer.name }}</td>
          <td class="text-overflow">{{ row.title }}</td>
          <td class="text-overflow">{{ row.description }}</td>
          <!-- <td>{{ format(row.commentCount) }}</td> -->
          <td>{{ row.commentCount }}</td>
          <td>{{ format(row.views) }}</td>
        </template>
      </base-table>
    </div>
  </div>
</template>
<script>
import { formatNumber } from '@/common/utils'

export default {
  name: 'MostViewLiveStreamTable',
  props: ['liveStreams'],
  methods: {
    format(number) {
      return formatNumber(number)
    }
  }
}
</script>
<style scoped>
.table th,
.table td {
  border-top: 0.5px solid rgba(220, 220, 220, 0.3) !important;
}
</style>
